
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-20037c22&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./DuePaymentList.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./DuePaymentList.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-20037c22!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./DuePaymentList.vue"),
  /* scopeId */
  "data-v-20037c22",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/microfinance/Collection/DuePaymentList.vue
// module id = 639
// module chunks = 0